export default {
  "1313161554": ["aurora-mainnet"],
  "1313161555": ["aurora-testnet"],
  "1313161556": ["aurora-localnet"],
};
